<template>
  <div class="r-outer">
    <canvas class="r-canvas" ref="chartJSContainer" width="300" height="200"></canvas>
    <canvas class="r-canvas" ref="secondContainer" width="300" height="200"></canvas>
    <canvas class="r-canvas" ref="thrContainer" width="300" height="200"></canvas>
    <div class="semi-circle">
      <div class="label" :style="positionLabel(value2 / 100)">{{value2}}%</div>

      <div class="semi-circle-w" v-if="isShowLabel">
        <div class="label label-w" :style="positionLabel(value1 / 100)">{{value1}}%</div>
      </div>
    </div>
    <p class="r-percent">
      {{ Math.round(label) }}%
    </p>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  props: ["value1", "value2", "label", "isShowLabel"],
  mounted() {
    this.createChart();
  },
  methods: {
    positionLabel(percentage) {
      // The angle in radians, offset by -90 degrees to start from the left
      const angle = (percentage * Math.PI) - Math.PI / 2;

      // Calculate the x and y coordinates
      const x = 50 + 50 * Math.cos(angle); // 50 is for centering and other 50 is for radius
      const y = 50 + 50 * Math.sin(angle);

      return {
        position: 'absolute',
        top:`${y}%`,
        left: `${x}%`
      }
    },
    calculatePosition(percentage) {
      const firstBar = 100 - percentage;
      const secondBar = percentage - 1;
      const thirdBar = 1;
      return [firstBar, thirdBar, secondBar];
    },
    createChart() {
      const options1 = {
        type: 'doughnut',
        data: {
          labels: ["dark Red", "Red", "Orange", "Green"],
          datasets: [
            {
              label: '# of Votes',
              data: [46, 22, 22, 10],
              backgroundColor: [
                'rgba(198, 36, 40, 1)',
                'rgba(231, 76, 60, 1)',
                'rgba(255, 164, 46, 1)',
                'rgba(46, 204, 113, 1)',

              ],
              borderColor: [
                'rgba(255, 255, 255 ,1)',
                'rgba(255, 255, 255 ,1)',
                'rgba(255, 255, 255 ,1)',
                'rgba(255, 255, 255 ,1)'
              ],
              borderWidth: 1
            }
          ]
        },
        options: {
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          },
          cutoutPercentage: 65,
        }
      }

      const ctx1 = this.$refs.chartJSContainer.getContext("2d");
      new Chart(ctx1, options1);

      const options2 = {
        type: 'doughnut',
        data: {
          labels: [null, this.value1, null],
          datasets: [
            {
              data: this.calculatePosition(100 - (this.value1 > 100 ? 100 : this.value1)),
              backgroundColor: [
                "rgba(0,0,0,0)",
                "rgba(0,0,0,1)",
                "rgba(0,0,0,0)",
              ],
              borderColor: [
                'rgba(0, 0, 0 ,0)',
                'rgba(0, 0, 0, 1)',
                'rgba(0, 0, 0 ,0)'
              ],
              borderWidth: 5
            }]
        },
        options: {
          showAllTooltips: false,
          cutoutPercentage: 34,
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          legend: {
            display: false
          },
          tooltips: {
            enabled: false,
          }
        },
      }

      const ctx2 = this.$refs.secondContainer.getContext("2d");
      new Chart(ctx2, options2);


      const options3 = {
        type: 'doughnut',
        data: {
          labels: [null, this.value2, null],
          datasets: [
            {
              data: this.calculatePosition(100 - (this.value2 > 100 ? 100 : this.value2)),
              backgroundColor: [
                "rgba(0,0,0,0)",
                "rgba(0,0,0,1)",
                "rgba(0,0,0,0)",
              ],
              borderColor: [
                'rgba(0, 0, 0 ,0)',
                'rgba(0, 0, 0, 1)',
                'rgba(0, 0, 0 ,0)'
              ],
              borderWidth: 0
            }]
        },
        options: {
          showAllTooltips: false,
          cutoutPercentage: 65,
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          legend: {
            display: false
          },
          tooltips: {
            enabled: false,
          }
        }
      }


      const ctx3 = this.$refs.thrContainer.getContext("2d");
      new Chart(ctx3, options3);
    },
  },
};
</script>

<style lang="scss" scoped>
.r-outer {
  position: relative;
  width: 280px;
  margin: 0 auto;
  margin-top: 30px;
  height: 200px;
}

.r-canvas {
  position: absolute;
}

.r-percent {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 20px;
  font-weight: 500;
  color: #000;
  bottom: 0;
}

.label {
  position: absolute;
  transform: translate(-50%, -50%) rotate(90deg);
  background: #fff;
}

.semi-circle {
  position: relative;
  width: 320px;
  height: 320px;
  transform: rotate(-90deg);
  margin-left: -20px;
}

.semi-circle-w {
  position: relative;
  width: 116px;
  height: 116px;
  margin-left: 74px;
  top: 102px;
}

.label-w {
  position: absolute;
  transform: translate(-50%, -50%) rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Analytics/components/ProgressBar.vue